// extracted by mini-css-extract-plugin
export default {"navbar":"HK_Tb4hi","brand":"ZSoZVxVj","brandLogo":"F71ieSxf","navRight":"a3Usb4ZH","weekText":"ULA0n1ax"};